import React from "react";

export const ChoosePasswordPanel = () => {
  return (
    <div className="absolute" style={{ inset: -2 }}>
      <picture>
        <source
          media="(min-width: 1024px)"
          srcSet="/design/images/login-page/choose-password-desktop.webp"
        />
        <img
          src="/design/images/login-page/choose-password-tablet.webp"
          alt="Choose password illustration"
          className="w-full h-full object-cover"
        />
      </picture>
      <div className="absolute z-10" style={{ top: "2.5rem", left: "2.5rem" }}>
        <img
          src="/design/images/login-page/breathe_logo_white.svg"
          alt="Breathe logo icon"
          className="h-8 w-9"
        />
      </div>
    </div>
  );
};
